import {
  bulkUploadSchemeTranslations,
  bulkUploadSchemes,
  downloadSchemeTranslationsBulkUploadTemplate,
  downloadSchemesBulkUploadTemplate,
} from "../../../../services/schemes/schemes";
import BulkUploadSection from "../../../../components/bulk_upload/bulk_upload_section";
import BulkUploadDialogShell from "../../../../components/bulk_upload/bulk_upload_dialog_shell";

interface BulkUploadSchemesDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function BulkUploadSchemesDialog({
  open,
  onClose,
}: BulkUploadSchemesDialogProps) {
  return (
    <BulkUploadDialogShell
      open={open}
      onClose={onClose}
      title="Bulk Upload Schemes"
      createTabLabel="Create Schemes"
      translationsTabLabel="Add Translations"
      createTabContent={
        <BulkUploadSection
          description="Upload an .xlsx file to create many schemes at once, in English. Download the template first for the exact column format and the valid names for Process Mode, Government Type, Category, Gender, State, and the other eligibility fields."
          templateFileName="schemes_bulk_upload_template.xlsx"
          onDownloadTemplate={downloadSchemesBulkUploadTemplate}
          onUpload={bulkUploadSchemes}
          savedLabel="created"
          listQueryKey="schemes"
        />
      }
      translationsTabContent={
        <BulkUploadSection
          description="Upload an .xlsx file to add translations to existing schemes - one row per Scheme ID + language. Find a scheme's ID on the Schemes list or its details page. New translations still need to be approved, same as adding one by hand."
          templateFileName="scheme_translations_bulk_upload_template.xlsx"
          onDownloadTemplate={downloadSchemeTranslationsBulkUploadTemplate}
          onUpload={bulkUploadSchemeTranslations}
          savedLabel="saved"
          listQueryKey="schemes"
        />
      }
    />
  );
}
